module.exports = __webpack_public_path__ + "toBride1-we-r-n.30462be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-r-n.jpg
// module id = p/NA
// module chunks = 0